export default __webpack_public_path__ + "static/media/background-cork.6e539443.jpg";